export default __webpack_public_path__ + "resources/icons/n340-cb07.png";